import { useLocation, useParams } from "react-router-dom";
import AOPAdmissionLetterBasicLayout from "@/src/components/AdmissionsOfficePage/documents/AdmissionLetterBasic/AOPAdmissionLetterBasicLayout";
import AOPInvoiceLetterBasicLayout from "@/src/components/AdmissionsOfficePage/documents/InvoiceLetterBasic/AOPInvoiceLetterBasicLayout";
import AOPAcknowledgementLetterBasicLayout from "@/src/components/AdmissionsOfficePage/documents/AcknowledgementLetterBasic/AOPAcknowledgementLetterBasicLayout";
import AOPPaymentConfirmationBasicLayout from "@/src/components/AdmissionsOfficePage/documents/PaymentConfirmationBasic/AOPPaymentConfirmationBasicLayout";
import AOPCertificateBasicLayout from "@/src/components/AdmissionsOfficePage/documents/CertificateBasic/AOPCertificateBasicLayout";
import AOPStudentLetterBasicLayout from "@/src/components/AdmissionsOfficePage/documents/StudentLetterBasic/AOPStudentLetterBasicLayout";
import AOPRequestLetterBasicLayout from "@/src/components/AdmissionsOfficePage/documents/RequestLetterBasic/AOPRequestLetterBasicLayout";
import AOPAdmissionLetterDoubleLangLayout from "@/src/components/AdmissionsOfficePage/documents/AdmissionLetterDoubleLang/AOPAdmissionLetterDoubleLangLayout";
import AOPInvoiceLetterDoubleLangLayout from "@/src/components/AdmissionsOfficePage/documents/InvoiceLetterDoubleLang/AOPInvoiceLetterDoubleLangLayout";

const AdmissionsOfficePage = () => {
  const { pathname } = useLocation();
  const {
    country,
    document,
    lang: langParam,
  } = useParams<{
    country?: string;
    document?: string;
    lang?: string;
  }>();

  const langFromPath = pathname.includes("/admissions-office/fr/") ? "fr" : pathname.includes("/admissions-office/de/") ? "de" : null;
  const lang = langFromPath ?? (langParam === "fr" || langParam === "de" ? langParam : "en");

  if (!country || !document) {
    return <div>Not found</div>;
  }

  switch (country) {
    case "malta": {
      switch (document) {
        case "admission":
          if (lang === "fr") return <AOPAdmissionLetterDoubleLangLayout country="malta" secondLang="fr" />;
          if (lang === "de") return <AOPAdmissionLetterDoubleLangLayout country="malta" secondLang="de" />;
          return <AOPAdmissionLetterBasicLayout country="malta" />;
        case "invoice":
          if (lang === "fr") return <AOPInvoiceLetterDoubleLangLayout country="malta" secondLang="fr" />;
          if (lang === "de") return <AOPInvoiceLetterDoubleLangLayout country="malta" secondLang="de" />;
          return <AOPInvoiceLetterBasicLayout country="malta" />;
        case "acknowledgement":
          return <AOPAcknowledgementLetterBasicLayout country="malta" />;
        case "payment":
          return <AOPPaymentConfirmationBasicLayout country="malta" />;
        case "student":
          return <AOPStudentLetterBasicLayout country="malta" />;
        case "certificates":
          return <AOPCertificateBasicLayout country="malta" />;
        default:
          return <div>Not found</div>;
      }
    }
    case "poland": {
      switch (document) {
        case "admission":
          return <AOPAdmissionLetterBasicLayout country="poland" />;
        case "invoice":
          return <AOPInvoiceLetterBasicLayout country="poland" />;
        case "payment":
          return <AOPPaymentConfirmationBasicLayout country="poland" />;
        case "acknowledgement":
          return <AOPAcknowledgementLetterBasicLayout country="poland" />;
        default:
          return <div>Not found</div>;
      }
    }
    case "ukraine": {
      switch (document) {
        case "admission":
          return <AOPAdmissionLetterBasicLayout country="ukraine" />;
        case "invoice":
          return <AOPInvoiceLetterBasicLayout country="ukraine" />;
        case "payment":
          return <AOPPaymentConfirmationBasicLayout country="ukraine" />;
        case "acknowledgement":
          return <AOPAcknowledgementLetterBasicLayout country="ukraine" />;
        case "request":
          return <AOPRequestLetterBasicLayout country="ukraine" />;
        default:
          return <div>Not found</div>;
      }
    }
    default:
      return <div>Not found</div>;
  }
};

export default AdmissionsOfficePage;
